// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetPopup_wrapper__aVVPA","title":"ResetPopup_title__bKf+A","btn":"ResetPopup_btn__Mlwu9"};